import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4h2n9rlls5: FaireBrandEntity = {
  token: "b_4h2n9rlls5",
  type: "brand",
  name: "Pink Lemonade",
  avatarUrl:
    "https://cdn.faire.com/fastly/1429262425098b1a4a4047a8e9bc71a12282e7cda643c7716c57a8efcfa0f90c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e5548558bcd1e465345cfd1fe499f8290d3d6a68151d8ed21b0ae066bfd6721e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1429262425098b1a4a4047a8e9bc71a12282e7cda643c7716c57a8efcfa0f90c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e5548558bcd1e465345cfd1fe499f8290d3d6a68151d8ed21b0ae066bfd6721e.jpeg",
  location: "Redwood city, CA, USA",
  minimumOrderDollars: 350,
  rating: 4.9,
  reviewCount: 22,
  isInsider: true,
  description:
    "Pink Lemonade was born out of a passion to create exquisite knitted products. Bringing together skilled artisans from Northern India and a team of designers with modern aesthetics, our delicate knitted weaves come in a variety of forms.\n\nFrom cozy throws to soft baby blankets to eye-catching makeup pouches, Pink Lemonade has something for everyone: homes, babies, and you.\n\nOver the years, we’ve evolved into a global brand that’s recognized for its quality by retailers and customers alike. That because at Pink Lemonade, our motto is to only sell what we love. And we believe you’ll love it too.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:08.451Z",
    importedBy: "entity-db-cli",
  },
};
